import { useNavigate, useParams } from "react-router-dom";
import DynamicFormPage from "../../components/DynamicFormPage";
import { getProductionPresetDetails } from "../../helpers/http_production_presets_requests";
import { useQuery } from "@tanstack/react-query";

export default function ProductionPresetDetails() {
    const navigate = useNavigate();
    const { id } = useParams();

    const { data, isFetching } = useQuery({
        queryKey: ["getProductionPresetDetails", id],
        queryFn: () => getProductionPresetDetails(id),
        staleTime: 1000 * 5,
    });

    const { data: presetData } = data?.data ?? {};

    const formFieldList = [
        {
            title: "Preset - Detalhes",
            fields: [
                { name: "name", label: "Nome", type: "text" },
                { name: "position", label: "Ordem", type: "number" },
                { name: "prod_steps_json", label: "Passos de Produção", type: "steps", fullWidth: true },
                { name: "is_active", label: "Ativo", type: "switch" },
            ],
        },
    ];

    return (
        <DynamicFormPage
            isLoading={isFetching}
            details
            initialData={presetData}
            title="Preset - Detalhes"
            formFieldList={formFieldList}
            onCancel={() => navigate(-1)}
        />
    );
}
